import React, { useState } from "react";
import { useSelector } from "react-redux";
import { PracticaTipoSolPresupuesto } from "./PracticaTipoSolPresupuesto";
import PracticaTipoPresupuestoSoloMateriales from "./PracticaTipoPresupuestoSoloMateriales";

export const PresupuestosPractica = (props) => {
  const [cantidad, setCantidad] = useState(
    props.practica ? props.practica?.cant : 1
  );
  const [valorUnitario, setValorUnitario] = useState(
    props.practica ? props.practica?.valorUnitario : null
  );

  const {
    presupuestoSeleccionado: { conInternacion = false, soloMateriales = false } = {},
  } = useSelector((state) => state.autorizaciones);

  const mostrarMateriales = conInternacion;

  return (
    soloMateriales ?
      <PracticaTipoPresupuestoSoloMateriales
      practica={props.practica}
      disabled={props.disabled}
      tieneIdPrescriptor={false}
      tieneMinimoUnMaterial={false}
      mostrarMateriales={mostrarMateriales}
      evaluarPracticasMateriales={props.evaluarPracticasMateriales}
      desdeAuditar={props.desdeAuditar}
      esDenunciaInternacion={false}
      filtros={props.filtros}
      />
      :
      <PracticaTipoSolPresupuesto
        cantidad={cantidad}
        practica={props.practica}
        setCantidad={setCantidad}
        disabled={props.disabled}
        conInternacion={conInternacion}
        desdeAuditar={props.desdeAuditar}
        mostrarMateriales={mostrarMateriales}
        evaluarPracticasMateriales={props.evaluarPracticasMateriales}
        valorUnitario={valorUnitario}
        setValorUnitario={setValorUnitario}
      />
  );
};
